import { createAction, createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxRootState } from "../../shared/redux/store";
import { withPayloadType } from "../../shared/utils";
import { KitItem } from "../../api/types";
import { ReduxClinicSubmissionState } from "../types";

const initialState: ReduxClinicSubmissionState = {
    availableKits: [],
    // Starts true (not false) - the page always dispatches loadAvailableKits once an org
    // resolves, so "haven't heard back yet" is the true state from the very first render, not
    // just once the request is actually in flight. Closes the window where the warning could
    // still flash for the one tick before that dispatch effect runs.
    availableKitsLoading: true,
};

export const loadAvailableKits = createAction('clinicSubmission/loadAvailableKits', withPayloadType<number | undefined>());

const clinicSubmissionSlice = createSlice({
    name: 'clinicSubmission',
    initialState,
    reducers: {
        setAvailableKits: (state, action: PayloadAction<KitItem[]>) => {
            state.availableKits = action.payload;
            state.availableKitsLoading = false;
        },
        setAvailableKitsLoading: (state, action: PayloadAction<boolean>) => {
            state.availableKitsLoading = action.payload;
        },
    },
});

export default clinicSubmissionSlice;

const selectSelf = (state: ReduxRootState) => state.clinicSubmission;
export const selectClinicSubmissionAvailableKits = createSelector(selectSelf, self => self.availableKits);
export const selectClinicSubmissionAvailableKitsLoading = createSelector(selectSelf, self => self.availableKitsLoading);
